var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.5151C1 11.9503 1.17285 12.3676 1.48053 12.6752C1.7882 12.9829 2.2055 13.1558 2.64062 13.1558H12.4844C12.9195 13.1558 13.3368 12.9829 13.6445 12.6752C13.9521 12.3676 14.125 11.9503 14.125 11.5151V7.00342H1V11.5151ZM2.93359 9.28857C2.93359 9.05547 3.02619 8.83192 3.19102 8.66709C3.35585 8.50227 3.5794 8.40967 3.8125 8.40967H5.21875C5.45185 8.40967 5.6754 8.50227 5.84023 8.66709C6.00506 8.83192 6.09765 9.05547 6.09765 9.28857V9.87451C6.09765 10.1076 6.00506 10.3312 5.84023 10.496C5.6754 10.6608 5.45185 10.7534 5.21875 10.7534H3.8125C3.5794 10.7534 3.35585 10.6608 3.19102 10.496C3.02619 10.3312 2.93359 10.1076 2.93359 9.87451V9.28857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4844 2.84302H2.64062C2.2055 2.84302 1.7882 3.01587 1.48053 3.32355C1.17285 3.63122 1 4.04852 1 4.48364V5.24536H14.125V4.48364C14.125 4.04852 13.9521 3.63122 13.6445 3.32355C13.3368 3.01587 12.9195 2.84302 12.4844 2.84302Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/CardIcon.9b2b6f85bcc4e259bac461738a3af583.svg";
export { ForwardRef as ReactComponent };